import * as Model from 'prosemirror-model';
export { Model };
import * as View from 'prosemirror-view';
import { EditorView } from 'prosemirror-view';
export { View };
import * as State from 'prosemirror-state';
import { PluginKey, Plugin, EditorState } from 'prosemirror-state';
export { State };
import * as KeyMap from 'prosemirror-keymap';
import { keydownHandler, keymap } from 'prosemirror-keymap';
export { KeyMap };
import * as Transform from 'prosemirror-transform';
export { Transform };
import * as Commands from 'prosemirror-commands';
import { setBlockType, wrapIn, lift, toggleMark as toggleMark$1, chainCommands, exitCode, joinUp, joinDown, selectParentNode, baseKeymap } from 'prosemirror-commands';
export { Commands };
import * as SchemaList from 'prosemirror-schema-list';
import { liftListItem, wrapInList, splitListItem, sinkListItem } from 'prosemirror-schema-list';
export { SchemaList };
import * as History from 'prosemirror-history';
import { undo, redo, history } from 'prosemirror-history';
export { History };
import * as InputRules from 'prosemirror-inputrules';
import { undoInputRule, wrappingInputRule, inputRules } from 'prosemirror-inputrules';
export { InputRules };
import * as DropCursor from 'prosemirror-dropcursor';
import { dropCursor } from 'prosemirror-dropcursor';
export { DropCursor };
import * as GapCursor from 'prosemirror-gapcursor';
import { gapCursor } from 'prosemirror-gapcursor';
export { GapCursor };
import { createElement, insertAfterElement, removeElement, getComposedEventPath, getParentElementOfType, setAttributes } from '@pluxbox/pbx-dom-lib';
import { createPopper } from '@popperjs/core';

const ProseMirror$1 = {
  model: Model,
  view: View,
  state: State,
  keymap: KeyMap,
  transform: Transform,
  commands: Commands,
  schemaList: SchemaList,
  history: History,
  inputRules: InputRules,
  dropCursor: DropCursor,
  gapCursor: GapCursor,
  allowInlineImageBlob: false,
  allowLongUrls: false,
};

if (typeof window !== 'undefined') window.ProseMirror = ProseMirror$1;
if (typeof process !== 'undefined') process.ProseMirror = ProseMirror$1;

class MenuViewPlugin {
  constructor (items, editorView) {
    this.onInputFocus = this.onInputFocus.bind(this);
    this.onInputBlur = this.onInputBlur.bind(this);

    editorView.dom.addEventListener('focus', this.onInputFocus);
    editorView.dom.addEventListener('blur', this.onInputBlur);

    if (document.activeElement === editorView.dom) {
      this.onInputFocus();
    }

    this.items = items;
    this.editorView = editorView;

    const children = [];

    for (const item of items) {
      item.dom = item.generateDomElement();
      children.push(item.dom);

      item.editorView = editorView;
      item.boot(editorView);
    }

    this.dom = createElement('div', {
      onmousedown: event => event.preventDefault(),
      class: 'menubar',
      children: children,
    });

    this.update();

    insertAfterElement(editorView.dom, this.dom);
  }

  update () {
    // for (const item of this.items) {
    // 	const active = item.command(this.editorView.state, null, this.editorView);
    // 	item.dom.style.display = active ? '' : '';
    // }
  }

  onInputFocus () {
    clearTimeout(this.inputFocusTimeout);
    this.dom.classList.add('inputFocus');
  }

  onInputBlur () {
    this.inputFocusTimeout = setTimeout(() => {
      this.dom.classList.remove('inputFocus');
    }, 100);
  }

  destroy () {
    const { editorView } = this;

    for (const item of this.items) {
      item.destroy(editorView);
    }
    editorView.dom.removeEventListener('focus', this.onInputFocus);
    editorView.dom.removeEventListener('blur', this.onInputBlur);
    removeElement(this.dom);
  }
}

var MenuViewPlugin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  'default': MenuViewPlugin
});

const pbxMenuPluginKey = new PluginKey('pbxMenu');
const pbxChangePluginKey = new PluginKey('pbxChange');
const pbxAnchorChangePluginKey = new PluginKey('pbxAnchorChange');

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var schema = createCommonjsModule(function (module, exports) {
const { Schema } = ProseMirror.model;
const { addListNodes } = ProseMirror.schemaList;

/*
Note: This file is also used by the websocket service. Do not include stuff that is not present in the code of the
service.
 */

const dataUrlRegex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+=[a-z\-]+)?)?(;base64)?,[a-z0-9!$&',()*+;=\-._~:@\/?%\s]*\s*$/i;
const wrongImageSourceUrl = '/wrong-image-source-inserted.png';

function alertUserWarning (message) {
  if (typeof window !== 'undefined') {
    alert(message);// @todo maybe add a nicer popup.
  }
}

function checkImageAttrs (attrs) {
  if (!ProseMirror.allowInlineImageBlob) {
    if (dataUrlRegex.test(attrs.src)) {
      attrs.src = wrongImageSourceUrl;
      alertUserWarning('Data blobs are not supported as image source. Use URL image button instead.');
    }
  }

  if (!ProseMirror.allowLongUrls) {
    if ((attrs.src || '').length > 1e4) {
      attrs.src = wrongImageSourceUrl;
      alertUserWarning('Urls longer then 10 thousand characters are not supported for image sources.');
    }
  }
}

exports.checkImageAttrs = checkImageAttrs;

const calcYchangeDomAttrs = (attrs, domAttrs = {}) => {
  domAttrs = Object.assign({}, domAttrs);
  if (attrs.ychange !== null) {
    domAttrs.ychange_user = attrs.ychange.user;
    domAttrs.ychange_state = attrs.ychange.state;
  }
  return domAttrs
};

const nodes = exports.nodes = {
  doc: {
    content: 'block+'
  },

  // A paragraph node
  // Represented as a `<p>` in the DOM
  paragraph: {
    attrs: {
      indent: { default: 0 },
      lineHeight: { default: 1 },
      alignText: { default: null },

      ychange: { default: null },
    },
    content: 'inline*',
    group: 'block',
    parseDOM: [
      {
        tag: 'p',
        getAttrs (paragraph) {
          const attrs = {};
          const hasClass = className => paragraph.classList.contains(className);

          if (hasClass('rm-text-align-center')) {
            attrs.alignText = 'center';
          } else if (hasClass('rm-text-align-left')) {
            attrs.alignText = null;
          } else if (hasClass('rm-text-align-right')) {
            attrs.alignText = 'right';
          } else if (hasClass('rm-text-align-justify')) {
            attrs.alignText = 'justify';
          }

          if (paragraph.style.lineHeight) {
            const lineHeightMatches = paragraph.style.lineHeight.match(/^\s*([0-9]+|[0-9]*\.[0-9]+)\s*em\s*$/);
            if (lineHeightMatches) {
              const lineHeightToValidate = parseFloat(lineHeightMatches[1]);
              switch (true) {
                case lineHeightToValidate < 1.1:
                  attrs.lineHeight = 0;
                  break

                case lineHeightToValidate >= 1.5 && lineHeightToValidate < 2: //_.inRange(lineHeightToValidate, 1.5, 2):
                  attrs.lineHeight = 2;
                  break

                case lineHeightToValidate >= 2 && lineHeightToValidate < 2.5: //_.inRange(lineHeightToValidate, 2, 2.5):
                  attrs.lineHeight = 3;
                  break

                case lineHeightToValidate >= 2.5:
                  attrs.lineHeight = 4;
                  break
              }
            }
          }

          const marginLeftMatches = paragraph.style.marginLeft.match(/([0-9]+)em/);
          if (marginLeftMatches) attrs.indent = parseInt(marginLeftMatches[1], 10);

          return attrs
        }
      },
    ],
    toDOM (node) {
      const { attrs: nodeAttrs } = node;
      const attrs = calcYchangeDomAttrs(nodeAttrs);

      function bindSirTogether (str1, str2) {
        let fullString = (str1 || '');
        if (str2) {
          if (!str1) fullString = str2;
          else fullString += ' ' + str2;
        }
        return fullString
      }

      switch (nodeAttrs.alignText) {
        case 'center':
          attrs.class = bindSirTogether(attrs.class, 'rm-text-align-center');
          break
        case 'right':
          attrs.class = bindSirTogether(attrs.class, 'rm-text-align-right');
          break
        case 'justify':
          attrs.class = bindSirTogether(attrs.class, 'rm-text-align-justify');
          break
      }

      switch (nodeAttrs.lineHeight) {
        case 0:
          attrs.style = bindSirTogether(attrs.style, 'line-height:1em;');
          break
        case 2:
          attrs.style = bindSirTogether(attrs.style, 'line-height:1.5em;');
          break
        case 3:
          attrs.style = bindSirTogether(attrs.style, 'line-height:2em;');
          break
        case 4:
          attrs.style = bindSirTogether(attrs.style, 'line-height:2.5em;');
          break
      }

      if (nodeAttrs.indent) {
        attrs.style = bindSirTogether(attrs.style, `margin-left:${nodeAttrs.indent}em;`);
      }

      return ['p', attrs, 0]
    }
  },

  // A blockquote node
  // Represented as `<blockquote>` in the DOM
  blockquote: {
    attrs: { ychange: { default: null } },
    content: 'block+',
    group: 'block',
    defining: true,
    parseDOM: [{ tag: 'blockquote' }],
    toDOM (node) {
      return ['blockquote', calcYchangeDomAttrs(node.attrs), 0]
    },
  },

  // A horizontal node
  // Represented as `<hr>` in the DOM
  horizontal_rule: {
    attrs: { ychange: { default: null } },
    group: 'block',
    parseDOM: [{ tag: 'hr' }],
    toDOM (node) {
      return ['hr', calcYchangeDomAttrs(node.attrs)]
    },
  },

  // The default node
  // This represents nothing in the DOM.
  text: {
    group: 'inline'
  },

  // A Image Node
  // Represented as an `<img>` in the DOM
  image: {
    inline: true,
    attrs: {
      ychange: { default: null },
      src: {},
      // alt: {default: null},
      // title: {default: null}
    },
    group: 'inline',
    draggable: true,
    parseDOM: [{
      tag: 'img[src]',
      getAttrs (dom) {
        const attrs = {
          src: dom.getAttribute('src'),
          // title: dom.getAttribute('title'),
          // alt: dom.getAttribute('alt')
        };

        checkImageAttrs(attrs);

        return attrs
      }
    }],
    toDOM (node) {
      const domAttrs = {
        src: node.attrs.src,
        // title: node.attrs.title,
        // alt: node.attrs.alt
      };

      checkImageAttrs(domAttrs);

      return ['img', calcYchangeDomAttrs(node.attrs, domAttrs)]
    }
  },

// A hard line break
// represented in the DOM as `<br>`.
  hard_break: {
    inline: true,
    group: 'inline',
    selectable: false,
    parseDOM: [
      { tag: 'br' },
    ],
    toDOM: () => ['br'],
  }
};

// :: Object [Specs](#model.MarkSpec) for the marks in the schema.
const marks = exports.marks = {

  // :: MarkSpec A link. Has `href` and `title` attributes. `title`
  // defaults to the empty string. Rendered and parsed as an `<a>`
  // element.
  link: {
    attrs: {
      href: {},
    },
    inclusive: false,
    parseDOM: [{
      tag: 'a[href]',
      getAttrs (dom) {
        return { href: dom.getAttribute('href') }
      }
    }],
    toDOM: node => ['a', node.attrs, 0],
  },

  size: {
    attrs: {
      size: { default: null }
    },
    inclusive: true,

    parseDOM: [
      { tag: 'h1', attrs: { size: 1 } },
      { tag: 'h2', attrs: { size: 2 } },
      { tag: 'h3', attrs: { size: 2 } },
      { tag: 'h4', attrs: { size: 4 } },
      { tag: 'h5', attrs: { size: 4 } },
      { tag: 'h6', attrs: { size: 4 } },

      {
        tag: 'span',
        getAttrs (node) {
          const hasClassName = name => node.classList.contains(name);
          if (hasClassName('rm-size-huge')) return { size: 1 }
          if (hasClassName('rm-size-large')) return { size: 2 }
          if (hasClassName('rm-size-small')) return { size: 4 }
          return false
        },
      },
    ],
    toDOM (node) {
      const attrs = {};

      switch (node.attrs.size) {
        case 1:
          attrs.class = 'rm-size-huge';
          break
        case 2:
          attrs.class = 'rm-size-large';
          break
        case 4:
          attrs.class = 'rm-size-small';
          break
      }

      return ['span', attrs, 0]
    }
  },

  // Italic styled letters
  em: {
    parseDOM: [{ tag: 'i' }, { tag: 'em' }, { style: 'font-style=italic' }],
    toDOM: () => ['em', 0],
  },

  // Bold styled letters
  strong: {
    parseDOM: [
      { tag: 'strong' },
      // This works around a Google Docs misbehavior where
      // pasted content will be inexplicably wrapped in `<b>`
      // tags with a font-weight normal.
      { tag: 'b', getAttrs: node => node.style.fontWeight !== 'normal' && null },
      { style: 'font-weight', getAttrs: value => /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null },
    ],
    toDOM: () => ['strong', 0],
  },

  // Underlined styled letters
  underline: {
    parseDOM: [
      { tag: 'u' },
      { style: 'text-decoration', getAttrs: value => /^underline$/.test(value) && null },
    ],
    toDOM: () => ['span', { style: 'text-decoration: underline' }, 0],
  },

  // Striketrough styled letters
  striketrough: {
    parseDOM: [
      { tag: 's' },
      { tag: 'strike' },
    ],
    toDOM: () => ['strike', 0],
  },

  fontColor: {
    attrs: {
      color: {},
    },
    parseDOM: [{ style: 'color', getAttrs: color => ({ color }) }],
    toDOM: node => ['span', { style: `color:${node.attrs.color};` }, 0],
  },

  backgroundColor: {
    attrs: {
      color: {},
    },
    parseDOM: [
      { style: 'background', getAttrs: color => ({ color }) },
      { style: 'background-color', getAttrs: color => ({ color }) },
    ],
    toDOM: node => ['span', { style: `background:${node.attrs.color};` }, 0],
  },

  ychange: {
    attrs: {
      user: { default: null },
      state: { default: null }
    },
    inclusive: false,
    parseDOM: [{ tag: 'ychange' }],
    toDOM (node) {
      return ['ychange', { ychange_user: node.attrs.user, ychange_state: node.attrs.state }, 0]
    }
  }
};

const baseSchema = exports.baseSchema = new Schema({ nodes, marks });
exports.ProseMirrorSchema = new Schema({
  nodes: addListNodes(baseSchema.spec.nodes, 'paragraph block*', 'block'),
  marks: baseSchema.spec.marks
});
});
var schema_1 = schema.checkImageAttrs;
var schema_2 = schema.nodes;
var schema_3 = schema.marks;
var schema_4 = schema.baseSchema;
var schema_5 = schema.ProseMirrorSchema;

/**
 * @property {EditorView} editorView
 * @property {HTMLElement} dom
 */
class BaseMenuItem {

  constructor () {
    this.command = this.command.bind(this);
  }

  /**
   * @returns {HTMLElement}
   */
  generateDomElement () {
    console.error('The "generateDomElement" method must be implemented in', this);
    return document.createElement('div')
  }

  /**
   *
   * @param {EditorState} state
   * @param {Function} dispatch
   * @param {EditorView} editorView
   * @param {Object} attrs
   */
  execute (state, dispatch, editorView, attrs) {
  }

  /**
   * @param {EditorView} editorView
   */
  boot (editorView) {
  }

  /**
   * @param {EditorView} editorView
   */
  destroy (editorView) {
  }

  generateFaIconMenuElement (iconName, className) {
    return createElement('span', {
      class: ['menuitem', className, 'fa', iconName],
      title: className,
    })
  }

  generateMaterialIconMenuElement (iconName, className) {
    return createElement('span', {
      class: ['menuitem', className],
      children: [
        createElement('i', {
          class: 'material-icons',
          children: [iconName],
        }),
      ],
      title: className,
    })
  }

  generateTextMenuElement (text, className) {
    return createElement('span', {
      class: ['menuitem', className],
      children: [text],
      title: className,
    })
  }

  command (attrs = {}) {
    this.editorView.focus();
    this.execute(
      this.editorView.state,
      this.editorView.dispatch,
      this.editorView,
      attrs,
    );
  }

}

class BasePopperMenuItem extends BaseMenuItem {

  constructor () {
    super();

    this.popperDestroyTimeout = 100;
  }

  /**
   * @returns {HTMLElement}
   */
  generatePopperDomElement () {
    console.error('The "generatePopperDomElement" method must be implemented in', this);
    return document.createElement('div')
  }

  boot (editorView) {
    super.boot(editorView);
    this.makePopperAndElement = this.makePopperAndElement.bind(this);
    this.debounceDestroyPopper = this.debounceDestroyPopper.bind(this);
    this.addPopperEventListeners(this.dom);
  }

  destroy (editorView) {
    super.destroy(editorView);
    this.removePopperEventListeners(this.dom);
  }

  addPopperEventListeners (element) {
    element.addEventListener('mouseover', this.makePopperAndElement);
    element.addEventListener('mouseout', this.debounceDestroyPopper);
  }

  removePopperEventListeners (element) {
    element.removeEventListener('mouseover', this.makePopperAndElement);
    element.removeEventListener('mouseout', this.debounceDestroyPopper);
  }

  clearPopperDebounce () {
    clearTimeout(this.popperDebounce);
  }

  makePopperAndElement () {
    if (this.popper) {
      this.clearPopperDebounce();
      return
    }

    const popperElement = this.generatePopperDomElement();
    this.addPopperEventListeners(popperElement);
    insertAfterElement(this.editorView.dom, popperElement);
    popperElement.classList.add('PopperJs');
    this.popperElement = popperElement;

    this.popper = this.createPopperClient(this.dom, popperElement);
  }

  destroyPopper () {
    this.clearPopperDebounce();

    this.popper.destroy();
    delete this.popper;

    this.removePopperEventListeners(this.popperElement);
    removeElement(this.popperElement);
    delete this.popperElement;
  }

  debounceDestroyPopper () {
    this.clearPopperDebounce();
    this.popperDebounce = setTimeout(() => {
      this.destroyPopper();
    }, this.popperDestroyTimeout);
  }

  createPopperClient (refElement, popperElement) {
    return createPopper(refElement, popperElement, {
      placement: 'bottom',
    })
  }

}

class BaseDropDownMenuItem extends BasePopperMenuItem {

  constructor () {
    super();

    this.popperAttributes = {};
    this.items = {};
  }

  /**
   * Parse attrs object to execute
   *
   * @param item
   * @returns {Object}
   */
  parseAttrs (item) {
    return {}
  }

  generatePopperDomElement () {
    const children = [
      ...(this.popperAttributes.children || []),
    ];

    for (const item in this.items) {
      if (!this.items.hasOwnProperty(item)) continue
      children.push(createElement('span', {
        children: [item],
        onmousedown: event => {
          event.preventDefault();
          this.command(this.parseAttrs(item));
          this.destroyPopper();
        },
      }));
    }

    return createElement('div', {
      ...this.popperAttributes,
      children: children,
    })
  }

}

function hasMarkInCurrentRange (markType, state) {
  const ranges = state.selection.ranges;
  let has = false;
  for (let i = 0; !has && i < ranges.length; i++) {
    let range = ranges[i];
    has = state.doc.rangeHasMark(
      range.$from.pos,
      range.$to.pos,
      markType,
    );
  }
  return has
}

function toggleMark (markTypeToToggle, shouldRemoveIfDefaultMark) {
  return (state, dispatch, attrs) => {
    const inSelection = hasMarkInCurrentRange(markTypeToToggle, state);
    const { ranges, $cursor } = state.selection;
    const transaction = state.tr;
    const markDefaultDisable = shouldRemoveIfDefaultMark(attrs);

    if ($cursor) {
      if (markTypeToToggle.isInSet(state.storedMarks || $cursor.marks())) {
        transaction.removeStoredMark(markTypeToToggle);
      }

      if (!markDefaultDisable) {
        transaction.addStoredMark(markTypeToToggle.create(attrs));
      }

      dispatch(transaction);
      return
    }

    if (markDefaultDisable) {
      if (inSelection) {
        for (let i = 0; i < ranges.length; i++) {
          const { $from, $to } = ranges[i];
          transaction.removeMark($from.pos, $to.pos, markTypeToToggle);
        }
      }
    } else {
      for (let i = 0; i < ranges.length; i++) {
        const { $from, $to } = ranges[i];
        if (inSelection) {
          transaction.removeMark($from.pos, $to.pos, markTypeToToggle);
        }
        transaction.addMark($from.pos, $to.pos, markTypeToToggle.create(attrs));
      }
    }

    dispatch(transaction.scrollIntoView());

  }
}

class SizingMenuItem extends BaseDropDownMenuItem {

  constructor () {
    super();

    this.items = {
      Huge: 1,
      Large: 2,
      Normal: 0,
      Small: 4,
    };

    this.popperAttributes = {
      class: 'SizeSelect',
    };
  }

  getMarkType () {
    return schema_5.marks.size
  }

  parseAttrs (size) {
    return {
      size: this.items[size],
    }
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_size', 'FontSizePicker')
  }

  execute (state, dispatch, editorView, attrs) {
    toggleMark(
      this.getMarkType(),
      (attrs => attrs.size === 0),
    )(state, dispatch, attrs);
  }

}

class BaseClickMenuItem extends BaseMenuItem {

  constructor () {
    super();

    this.onMenuButtonMouseDown = this.onMenuButtonMouseDown.bind(this);
  }

  boot (editorView) {
    super.boot(editorView);
    this.dom.addEventListener('mousedown', this.onMenuButtonMouseDown);
  }

  destroy (editorView) {
    super.destroy(editorView);
    this.dom.removeEventListener('mousedown', this.onMenuButtonMouseDown);
  }

  /**
   * Default attributes
   *
   * @returns {Object}
   */
  getBaseAttrs () {
    return {}
  }

  onMenuButtonMouseDown (event) {
    if (!this.executeClickAction(event)) {
      return
    }

    event.preventDefault();
    this.command(this.getBaseAttrs());
  }

  /**
   * @param {MouseEvent} event
   * @returns {boolean}
   */
  executeClickAction (event) {
    return true
  }

}

class BaseSetBlockTypeMenuItem extends BaseClickMenuItem {

  constructor (node, attrs = {}) {
    super();
    this.node = node;
    this.attrs = attrs;
  }

  updateAttrs (attrs) {
    return {
      ...this.attrs,
      ...attrs,
    }
  }

  execute (state, dispatch, editorView, attrs) {
    setBlockType(this.node, this.updateAttrs(attrs))(state, dispatch, editorView);
  }

}

function findParentNodeClosestToPos ($pos, predicate) {
  for (let i = $pos.depth; i > 0; i--) {
    const node = $pos.node(i);
    if (predicate(node)) {
      return {
        pos: i > 0 ? $pos.before(i) : 0,
        start: $pos.start(i),
        depth: i,
        node: node
      }
    }
  }
}

function findParentNode (predicate) {
  return selection => findParentNodeClosestToPos(selection.$from, predicate)
}

const getFirstParentNode = findParentNode(() => true);

class TextAlignMenuItem extends BaseSetBlockTypeMenuItem {

  constructor (alignText, icon) {
    super(schema_5.nodes.paragraph, {
      alignText: alignText,
    });
    this.icon = icon;
  }

  updateAttrs (attrs) {
    const paragraph = getFirstParentNode(this.editorView.state.selection);

    return {
      ...paragraph.node.attrs,
      ...this.attrs,
      ...attrs,
    }
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement(this.icon, 'Text_Alignment')
  }

}

class DividerMenuItem extends BaseMenuItem {

  generateDomElement () {
    return this.generateTextMenuElement('', 'Divider')
  }

}

class FontColorMenuItem extends BasePopperMenuItem {

  constructor () {
    super();

    this.shouldRemoveMark = this.shouldRemoveMark.bind(this);

    this.colors = [
      '#000000', '#e60000', '#ff9900', '#ffff00',
      '#008a00', '#0066cc', '#9933ff', '#ffffff',
      '#facccc', '#ffebcc', '#ffffcc', '#cce8cc',
      '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666',
      '#ffc266', '#ffff66', '#66b966', '#66a3e0',
      '#c285ff', '#888888', '#a10000', '#b26b00',
      '#b2b200', '#006100', '#0047b2', '#6b24b2',
      '#444444', '#5c0000', '#663d00', '#666600',
      '#003700', '#002966', '#3d1466',
    ];
  }

  getMarkType () {
    return schema_5.marks.fontColor
  }

  /**
   * Check if value is the default value
   *
   * @param attrs
   * @returns {boolean}
   */
  shouldRemoveMark (attrs) {
    return attrs.color === '#000000'
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('text_format', 'FontColorPicker')
  }

  generatePopperDomElement () {
    return createElement('div', {
      class: 'ColorSelect',
      children: this.colors.map(color => {
        return createElement('div', {
          style: `--color:${color};`,
          onmousedown: event => {
            event.preventDefault();
            this.command({ color });
          },
        })
      }),
    })
  }

  execute (state, dispatch, editorView, attrs) {
    toggleMark(
      this.getMarkType(),
      this.shouldRemoveMark,
    )(state, dispatch, attrs);
  }

}

class BackgroundColorMenuItem extends FontColorMenuItem {

  getMarkType () {
    return schema_5.marks.backgroundColor
  }

  shouldRemoveMark (attrs) {
    return attrs.color === '#ffffff'
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('font_download', 'BackgroundColorPicker')
  }

}

class LineHeightMenuItem extends BaseDropDownMenuItem {

  constructor () {
    super();

    this.items = {
      'No Space': 0,
      'Normal': 1,
      'Medium': 2,
      'Large': 3,
      'Extra Large': 4,
    };

    this.popperAttributes = {
      class: 'SizeSelect',
    };
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_line_spacing', 'LineHeightPicker')
  }

  parseAttrs (lineHeight) {
    return {
      lineHeight: this.items[lineHeight],
    }
  }

  execute (state, dispatch, editorView, newAttributes) {
    const paragraph = getFirstParentNode(state.selection);
    setBlockType(schema_5.nodes.paragraph, {
      ...paragraph.node.attrs,
      ...newAttributes,
    })(state, dispatch);
  }

}

class BaseWrapInNodeMenuItem extends BaseClickMenuItem {

  constructor (node, attrs = {}) {
    super();
    this.node = node;
    this.attrs = attrs;
  }

  execute (state, dispatch, editorView, attrs) {
    wrapIn(this.node, {
      ...this.attrs,
      ...attrs,
    })(state, dispatch, editorView);
  }

}

function findParentNodeOfType (nodeType) {
  const predicate = node => nodeType.name === node.type.name;
  return selection => findParentNode(predicate)(selection)
}

class BlockquoteMenuItem extends BaseWrapInNodeMenuItem {

  constructor () {
    super(schema_5.nodes.blockquote);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_quote', 'Blockquote')
  }

  execute (state, dispatch, editorView, attrs) {
    const { selection } = state;
    const blockquote = findParentNodeOfType(this.node)(selection);

    if (!blockquote) {
      return super.execute(state, dispatch, editorView, attrs)
    }

    lift(state, dispatch);
  }

}

class BaseListTypeMenuItem extends BaseClickMenuItem {

  constructor (listType, attrs = {}) {
    super();
    this.listType = listType;
    this.attrs = attrs;

    this.allListTypes = [
      schema_5.nodes.bullet_list,
      schema_5.nodes.ordered_list,
    ];
  }

  execute (state, dispatch, editorView, attrs) {

    const { name: listTypeName } = this.listType;
    const { selection } = state;

    const fromNode = selection.$from.node(selection.$from.depth - 2);
    const endNode = selection.$to.node(selection.$to.depth - 2);

    let callable = liftListItem(schema_5.nodes.list_item);

    const isNodeOfType = (node, nodeType) => node && node.type.name === nodeType;
    const checkSelectionHasNode = nodeType => isNodeOfType(fromNode, nodeType) && isNodeOfType(endNode, nodeType);

    if (!checkSelectionHasNode(listTypeName)) {
      const createListItemCommand = wrapInList(this.listType, { ...this.attrs, ...attrs });
      const isCurrentlyInList = this.allListTypes.findIndex(listType => (
        listType && checkSelectionHasNode(listType.name)
      )) !== -1;

      if (isCurrentlyInList) {
        // Execute remove list item after that set the callable to create a list item. The toggle method
        callable(state, dispatch);
      }

      callable = createListItemCommand;
    }

    callable(editorView.state, editorView.dispatch);
  }

}

class OrderedListMenuItem extends BaseListTypeMenuItem {

  constructor () {
    super(schema_5.nodes.ordered_list);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_list_numbered', 'Ordered_List')
  }

}

class BulletListMenuItem extends BaseListTypeMenuItem {

  constructor () {
    super(schema_5.nodes.bullet_list);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_list_bulleted', 'Bullet_List')
  }

}

class IncreaseIndentMenuItem extends BaseSetBlockTypeMenuItem {

  constructor () {
    super(schema_5.nodes.paragraph);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_indent_increase', 'IncreaseIndent')
  }

  transFromAttributes (attrs) {
    attrs.indent = (attrs.indent || 0) + 1;
  }

  updateAttrs (attrs) {
    const paragraph = getFirstParentNode(this.editorView.state.selection);

    if (paragraph.node.type === this.node) {
      attrs = {
        ...paragraph.node.attrs,
        ...attrs,
      };
    }

    attrs = {
      ...this.attrs,
      ...attrs,
    };

    this.transFromAttributes(attrs);
    return attrs
  }

}

class DecreaseIndentMenuItem extends IncreaseIndentMenuItem {

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_indent_decrease', 'DecreaseIndent')
  }

  transFromAttributes (attrs) {
    attrs.indent = (attrs.indent || 0) - 1;
    if (attrs.indent < 0) attrs.indent = 0;
  }

}

class BaseToggleMarkMenuItem extends BaseClickMenuItem {

  constructor (mark, attrs = {}) {
    super();
    this.mark = mark;
    this.attrs = attrs;
  }

  execute (state, dispatch, editorView, attrs) {
    toggleMark$1(this.mark, this.attrs)(state, dispatch);
  }

}

class BoldMenuItem extends BaseToggleMarkMenuItem {

  constructor () {
    super(schema_5.marks.strong);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_bold', 'Bold')
  }

}

class ItalicMenuItem extends BaseToggleMarkMenuItem {

  constructor () {
    super(schema_5.marks.em);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_italic', 'Italic')
  }

}

class UnderlinedMenuItem extends BaseToggleMarkMenuItem {

  constructor () {
    super(schema_5.marks.underline);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_underline', 'Underlined')
  }

}

class StrikeTroughMenuItem extends BaseToggleMarkMenuItem {

  constructor () {
    super(schema_5.marks.striketrough);
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('strikethrough_s', 'StrikeTrough')
  }

}

class StyleResetMenuItem extends BaseClickMenuItem {

  constructor () {
    super();

    this.markTypes = [
      schema_5.marks.size,
      schema_5.marks.em,
      schema_5.marks.strong,
      schema_5.marks.underline,
      schema_5.marks.striketrough,
      schema_5.marks.fontColor,
      schema_5.marks.backgroundColor,
    ];
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('format_clear', 'ClearStyling')
  }

  execute (state, dispatch, editorView, attrs) {
    const transaction = state.tr;
    const { ranges } = state.selection;

    for (let i = 0; i < ranges.length; i++) {
      const { $from, $to } = ranges[i];

      for (const markType of this.markTypes) {
        transaction.removeStoredMark(markType);
        transaction.removeMark($from.pos, $to.pos, markType);
      }
    }

    dispatch(transaction);
  }
}

class LinkEditMenuPopper {

  constructor (editorView, referenceElement, page = `main`) {
    this.destroyed = false;
    this.referenceElement = referenceElement;
    this.editorView = editorView;

    this.deleteLinkMenuAction = this.deleteLinkMenuAction.bind(this);
    this.saveLinkMenu = this.saveLinkMenu.bind(this);
    this.destroy = this.destroy.bind(this);

    const popperElement = createElement('div', {
      class: 'LinkTooltip PopperJs',
      style: 'z-index:100000'
    });

    insertAfterElement(editorView.dom, popperElement);
    this.popperElement = popperElement;

    // Get the href attribute by the getAttribute function.
    // Google chrome returns a wrong value when fetching it from the href property
    const href = referenceElement.getAttribute('href');
    if (page === 'edit') {
      this.editLinkMenu(href);
    } else {
      this.mainLinkMenu(href);
    }

    this.documentClickHandler = event => {

      const eventPath = getComposedEventPath(event);
      const clickedOnProseMirror = eventPath.includes(editorView.dom.parentElement);
      const clickedOnPopper = eventPath.includes(popperElement);

      if (!clickedOnPopper && !clickedOnProseMirror) {
        this.destroy();
      }
    };

    document.body.addEventListener('click', this.documentClickHandler);
    this.popper = createPopper(referenceElement, popperElement, {
      placement: 'bottom',
      positionFixed: true
    });
  }

  isValueEmpty (value) {
    return !value || value === 'https://'
  }

  saveLinkMenu (link) {
    return () => {
      const { editHrefPopperInput, referenceElement } = this;
      const newValue = editHrefPopperInput.value;
      delete this.editHrefPopperInput;

      if (this.isValueEmpty(newValue)) {
        return this.deleteLinkMenuAction()
      }

      if (link !== newValue) {
        const parentElement = getParentElementOfType(referenceElement, HTMLParagraphElement);
        referenceElement.setAttribute('href', newValue);

        // @todo find a better update method. (This will force the update in prose mirror. We can look to the Widget method in the future)
        // @todo refactor to a pm widget
        const content = parentElement.innerHTML;
        parentElement.innerHTML += ' ';

        setTimeout(() => {
          parentElement.innerHTML = content;
        });
      }

      this.destroy();
      // this.editorView.focus();
    }
  }

  deleteLinkMenuAction () {
    const { referenceElement } = this;
    referenceElement.outerHTML = referenceElement.innerHTML;

    this.destroy();
  }

  clearPopperElement () {
    this.popperElement.innerHTML = '';
  }

  mainLinkMenu (link) {
    this.clearPopperElement();
    setAttributes(this.popperElement, {
      'data-link': link,

      children: [

        createElement('p', {
          children: ['Visit URL:']
        }),

        createElement('a', {
          class: 'pm-preview',
          target: '_blank',
          rel: 'noopener noreferrer',
          href: link,
          children: [link]
        }),

        createElement('a', {
          onclick: () => this.editLinkMenu(link),
          class: 'pm-action',
          children: ['Edit']
        }),

        createElement('a', {
          class: 'pm-remove',
          onclick: this.deleteLinkMenuAction,
          children: ['Delete']
        }),

        createElement('a', {
          class: 'pm-action',
          onclick: this.destroy,
          children: ['Close']
        })

      ]
    });
  }

  editLinkMenu (link) {
    this.clearPopperElement();
    setAttributes(this.popperElement, {
      'data-link': link,

      children: [

        createElement('p', {
          children: ['Enter link:']
        }),

        this.editHrefPopperInput = createElement('input', {
          type: 'text',
          placeholder: 'https://example.com',
          value: link
        }),

        createElement('a', {
          class: 'pm-action',
          onclick: this.saveLinkMenu(link),
          children: ['Save']
        }),

        createElement('a', {
          class: 'pm-action',
          onclick: () => {
            if (this.isValueEmpty(link)) {
              return this.deleteLinkMenuAction()
            }
            return this.destroy()
          },
          children: ['Close']
        })

      ]
    });

    this.editHrefPopperInput.focus();
  }

  destroy () {
    document.body.removeEventListener('click', this.documentClickHandler);
    removeElement(this.popperElement);
    this.popper.destroy();
    this.destroyed = true;
  }

}

class LinkMenuItem extends BaseClickMenuItem {

  constructor () {
    super();

    this.onClickLink = this.onClickLink.bind(this);
  }

  getBaseAttrs () {
    return {
      href: 'https://'
    }
  }

  boot (editorView) {
    super.boot(editorView);
    editorView.dom.addEventListener('click', this.onClickLink);
    this.proseMirrorContainer = editorView.dom.parentElement;
  }

  destroy (editorView) {
    super.destroy(editorView);
    this.editorView.dom.removeEventListener('click', this.onClickLink);
    this.destroyPopper();
  }

  generateDomElement () {
    return this.generateMaterialIconMenuElement('insert_link', 'Link')
  }

  execute (state, dispatch, editorView, attrs) {
    const markType = schema_5.marks.link;
    const hasMarkInRange = hasMarkInCurrentRange(markType, state);
    const { ranges } = state.selection;

    /** @var {Transaction} */
    const transaction = state.tr;
    let hasNoSelection = true;

    if (hasMarkInRange) {
      for (let i = 0; i < ranges.length; i++) {
        const { $from, $to } = ranges[i];
        if ($from.pos !== $to.pos) {
          hasNoSelection = false;
          transaction.removeMark($from.pos, $to.pos, markType);
        }
      }
    } else {
      for (let i = 0; i < ranges.length; i++) {
        const { $from, $to } = ranges[i];
        if (hasMarkInRange) {
          if ($from.pos !== $to.pos) {
            hasNoSelection = false;
            transaction.removeMark($from.pos, $to.pos, markType);
          }
        }

        const mark = markType.create(attrs);
        if ($from.pos !== $to.pos) {
          hasNoSelection = false;
          transaction.addMark($from.pos, $to.pos, mark);
        }
      }
    }

    if (hasNoSelection) {
      console.log('There is no range to insert or delete a link');
      return
    }

    dispatch(transaction.scrollIntoView());

    this.destroyPopper();

    if (!hasMarkInRange) {
      // @todo make this better in the future
      const newAnchorElement = this.editorView.dom.querySelector(`a[href="https://"]`);
      this.editPopper = new LinkEditMenuPopper(this.editorView, newAnchorElement, 'edit');
    }
  }

  // Link popper
  destroyPopper () {
    if (this.editPopper && !this.editPopper.destroyed) {
      this.editPopper.destroy();
    }
  }

  onClickLink (event) {
    const targetElement = getComposedEventPath(event)
      .find(element => element instanceof HTMLAnchorElement);

    this.destroyPopper();
    if (targetElement) {
      this.editPopper = new LinkEditMenuPopper(this.editorView, targetElement);
    }
  }

}

class HeadingMenuItem extends BaseClickMenuItem {

  constructor() {
    super(schema_5.nodes.image);
  }

  generateDomElement() {
    return this.generateMaterialIconMenuElement('insert_photo', 'Image');
  }

  execute(state, dispatch, editorView, attrs) {
    const imageSrc = prompt('Enter Image URL', 'https://');
    if (imageSrc !== null && imageSrc !== false) {
      const attrs = {
        src: imageSrc,
      };
      schema_1(attrs);
      dispatch(state.tr.replaceSelectionWith(
        schema_5.nodes.image.createAndFill(attrs),
      ));
    }
  }

}

function buildMenuPlugin ({
  MenuView = MenuViewPlugin
} = {}) {

  const menuItems = [

    new SizingMenuItem(),
    new TextAlignMenuItem('left', 'format_align_left'),
    new TextAlignMenuItem('center', 'format_align_center'),
    new TextAlignMenuItem('right', 'format_align_right'),
    new TextAlignMenuItem('justify', 'format_align_justify'),

    new DividerMenuItem(),

    new FontColorMenuItem(),
    new BackgroundColorMenuItem(),

    new DividerMenuItem(),

    new LineHeightMenuItem(),
    new BlockquoteMenuItem(),

    new DividerMenuItem(),

    new OrderedListMenuItem(),
    new BulletListMenuItem(),
    new DecreaseIndentMenuItem(),
    new IncreaseIndentMenuItem(),

    new DividerMenuItem(),

    new BoldMenuItem(),
    new ItalicMenuItem(),
    new UnderlinedMenuItem(),
    new StrikeTroughMenuItem(),
    new StyleResetMenuItem(),

    new DividerMenuItem(),

    new LinkMenuItem(),
    new HeadingMenuItem(),
  ];

  return new Plugin({
    key: pbxMenuPluginKey,
    view: editorView => new MenuView(menuItems, editorView),
  })
}

var buildMenuPlugin$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildMenuPlugin: buildMenuPlugin
});

function setOrUpdateNode (nodeType, changeAttrs) {
  return function (editorState, dispatch, editorView) {
    const currentNode = getFirstParentNode(editorState.selection);
    let attrs = {};

    if (currentNode.node.type === nodeType) {
      attrs = { ...currentNode.node.attrs };
    }

    changeAttrs(attrs);
    return setBlockType(nodeType, attrs)(editorState, dispatch, editorView)
  }
}

const mac = typeof navigator != 'undefined' ? /Mac/.test(navigator.platform) : false;

// :: (Schema, ?Object) → Object
// Inspect the given schema looking for marks and nodes from the
// basic schema, and if found, add key bindings related to them.
// This will add:
//
// * **Mod-b** for toggling [strong](#schema-basic.StrongMark)
// * **Mod-i** for toggling [emphasis](#schema-basic.EmMark)
// * **Mod-`** for toggling [code font](#schema-basic.CodeMark)
// * **Ctrl-Shift-0** for making the current textblock a paragraph
// * **Ctrl-Shift-1** to **Ctrl-Shift-Digit6** for making the current
//   textblock a heading of the corresponding level
// * **Ctrl-Shift-Backslash** to make the current textblock a code block
// * **Ctrl-Shift-8** to wrap the selection in an ordered list
// * **Ctrl-Shift-9** to wrap the selection in a bullet list
// * **Ctrl->** to wrap the selection in a block quote
// * **Enter** to split a non-empty textblock in a list item while at
//   the same time splitting the list item
// * **Mod-Enter** to insert a hard break
// * **Mod-_** to insert a horizontal rule
// * **Backspace** to undo an input rule
// * **Alt-ArrowUp** to `joinUp`
// * **Alt-ArrowDown** to `joinDown`
// * **Mod-BracketLeft** to `lift`
// * **Escape** to `selectParentNode`
//
// You can suppress or map these bindings by passing a `mapKeys`
// argument, which maps key names (say `"Mod-B"` to either `false`, to
// remove the binding, or a new key name string.
function buildKeymap (schema, mapKeys) {

  const keys = {};

  function bind (key, cmd) {
    if (mapKeys) {
      let mapped = mapKeys[key];
      if (mapped === false) return
      if (mapped) key = mapped;
    }
    keys[key] = cmd;
  }

  bind('Mod-z', undo);
  bind('Shift-Mod-z', redo);
  bind('Backspace', undoInputRule);
  if (!mac) bind('Mod-y', redo);

  bind('Alt-ArrowUp', joinUp);
  bind('Alt-ArrowDown', joinDown);
  bind('Mod-BracketLeft', lift);
  bind('Escape', selectParentNode);

  if (schema.marks.strong) {
    bind('Mod-b', toggleMark$1(schema.marks.strong));
    bind('Mod-B', toggleMark$1(schema.marks.strong));
  }

  if (schema.marks.em) {
    bind('Mod-i', toggleMark$1(schema.marks.em));
    bind('Mod-I', toggleMark$1(schema.marks.em));
  }

  if (schema.marks.underline) {
    bind('Mod-u', toggleMark$1(schema.marks.underline));
    bind('Mod-U', toggleMark$1(schema.marks.underline));
  }

  if (schema.marks.code) {
    bind('Mod-`', toggleMark$1(schema.marks.code));
  }

  if (schema.nodes.bullet_list) {
    bind('Shift-Ctrl-8', wrapInList(schema.nodes.bullet_list));
  }

  if (schema.nodes.ordered_list) {
    bind('Shift-Ctrl-9', wrapInList(schema.nodes.ordered_list));
  }

  if (schema.nodes.blockquote) {
    bind('Ctrl->', wrapIn(schema.nodes.blockquote));
  }

  if (schema.nodes.hard_break) {
    const br = schema.nodes.hard_break;
    const cmd = chainCommands(exitCode, (state, dispatch) => {
      dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
      return true
    });
    bind('Mod-Enter', cmd);
    bind('Shift-Enter', cmd);
    if (mac) bind('Ctrl-Enter', cmd);
  }

  if (schema.nodes.list_item) {
    bind('Enter', splitListItem(schema.nodes.list_item));
    bind('Mod-[', liftListItem(schema.nodes.list_item));
    bind('Mod-]', sinkListItem(schema.nodes.list_item));
  }

  if (schema.nodes.paragraph) {
    bind('Shift-Ctrl-0', setBlockType(schema.nodes.paragraph));

    bind('Tab', setOrUpdateNode(schema.nodes.paragraph, attrs => {
      attrs.indent = (attrs.indent || 0) + 1;
    }));

    bind('Shift-Tab', setOrUpdateNode(schema.nodes.paragraph, attrs => {
      attrs.indent = Math.max((attrs.indent || 0) - 1, 0);
    }));
  }

  if (schema.nodes.code_block) {
    bind('Shift-Ctrl-\\', setBlockType(schema.nodes.code_block));
  }

  if (schema.nodes.heading) {
    for (let i = 1; i <= 6; i++) {
      bind('Shift-Ctrl-' + i, setBlockType(
        schema.nodes.heading,
        { level: i }
      ));
    }
  }

  if (schema.nodes.horizontal_rule) {
    let hr = schema.nodes.horizontal_rule;
    bind('Mod-_', (state, dispatch) => {
      dispatch(state.tr.replaceSelectionWith(hr.create()).scrollIntoView());
      return true
    });
  }

  return keys
}

var buildKeymap$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildKeymap: buildKeymap
});

function buildInputRules (schema) {
  const rules = [];

  rules.push(wrappingInputRule(/^\s*([-+*])\s$/, schema.nodes.bullet_list));
  rules.push(wrappingInputRule(/^(\d+)\.\s$/, schema.nodes.ordered_list));

  return inputRules({ rules })
}

var buildInputRules$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  buildInputRules: buildInputRules
});

var css_248z = "@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n.ProseMirror {\n  position: relative; }\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  white-space: break-spaces;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n  font-feature-settings: \"liga\" 0;\n  /* the above doesn't seem to work in Edge */ }\n\n.ProseMirror pre {\n  white-space: pre-wrap; }\n\n.ProseMirror li {\n  position: relative; }\n\n.ProseMirror-hideselection *::selection {\n  background: transparent; }\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent; }\n\n.ProseMirror-hideselection {\n  caret-color: transparent; }\n\n.ProseMirror-selectednode {\n  outline: 2px solid #8cf; }\n\n/* Make sure li selections wrap around markers */\nli.ProseMirror-selectednode {\n  outline: none; }\n\nli.ProseMirror-selectednode:after {\n  content: \"\";\n  position: absolute;\n  left: -32px;\n  right: -2px;\n  top: -2px;\n  bottom: -2px;\n  border: 2px solid #8cf;\n  pointer-events: none; }\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute; }\n\n.ProseMirror-gapcursor:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite; }\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden; } }\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block; }\n\n.ProseMirror-Style-Container {\n  word-wrap: break-word; }\n  .ProseMirror-Style-Container p {\n    line-height: 1.42em; }\n  .ProseMirror-Style-Container blockquote {\n    border-left: 4px solid #ccc;\n    margin: 5px 0;\n    padding-left: 16px; }\n  .ProseMirror-Style-Container .rm-size-huge {\n    font-size: 2.5em; }\n  .ProseMirror-Style-Container .rm-size-large {\n    font-size: 1.5em; }\n  .ProseMirror-Style-Container .rm-size-small {\n    font-size: 0.75em; }\n  .ProseMirror-Style-Container .rm-text-align-center {\n    text-align: center;\n    justify-content: center; }\n  .ProseMirror-Style-Container .rm-text-align-left {\n    text-align: left;\n    justify-content: left; }\n  .ProseMirror-Style-Container .rm-text-align-right {\n    text-align: right;\n    justify-content: right; }\n  .ProseMirror-Style-Container .rm-text-align-justify {\n    text-align: justify; }\n  .ProseMirror-Style-Container ol, .ProseMirror-Style-Container ul {\n    padding-left: 0; }\n  .ProseMirror-Style-Container li {\n    list-style-type: none;\n    margin-left: 40px; }\n    .ProseMirror-Style-Container li:not(:first-child) > p {\n      margin-top: 0; }\n    .ProseMirror-Style-Container li:not(:last-child) > p {\n      margin-bottom: 0; }\n    .ProseMirror-Style-Container li p ~ p {\n      margin-top: 0; }\n    .ProseMirror-Style-Container li li > p {\n      margin-top: 0;\n      margin-bottom: 0; }\n    .ProseMirror-Style-Container li > p:first-of-type:before {\n      content: '\\2022' ' ';\n      width: 40px;\n      margin-left: -40px;\n      position: absolute;\n      text-align: end; }\n  .ProseMirror-Style-Container ol {\n    counter-reset: list-item-num; }\n    .ProseMirror-Style-Container ol > li > p:first-of-type:before {\n      counter-increment: list-item-num;\n      content: counter(list-item-num, decimal) \". \"; }\n  .ProseMirror-Style-Container img {\n    max-width: 100%;\n    min-width: 1em;\n    min-height: 1em; }\n\n:host {\n  --proseMirror-menu-color: rgba(255, 255, 255, .6);\n  --proseMirror-menu-background: rgba(0, 0, 0, 0.8);\n  --proseMirror-menu-hoverColor: #ffffff;\n  --proseMirror-menu-zIndex: 99;\n  --proseMirror-menu-border-radius: 4px;\n  --proseMirror-menu-top: 0px;\n  --proseMirror-menu-bottom: -25px;\n  --proseMirror-border-width: 1px;\n  --proseMirror-border-color: rgb(224, 224, 224);\n  --proseMirror-active-border-color: #6AB103;\n  --proseMirror-menuItem-height: 24px;\n  --proseMirror-menuDivider-width: 1px;\n  --proseMirror-menuDivider-margin: 5px; }\n\n.PopperJs {\n  z-index: 9999; }\n  .PopperJs[x-out-of-boundaries] {\n    display: none; }\n\n.container {\n  display: flex;\n  flex-direction: column; }\n  .container[data-menu-position=\"top\"] {\n    flex-direction: column-reverse; }\n    .container[data-menu-position=\"top\"] .menubar {\n      border-top-left-radius: var(--proseMirror-menu-border-radius);\n      border-top-right-radius: var(--proseMirror-menu-border-radius);\n      top: var(--proseMirror-menu-top); }\n  .container[data-menu-position=\"bottom\"] .menubar {\n    border-bottom-right-radius: var(--proseMirror-menu-border-radius);\n    border-bottom-left-radius: var(--proseMirror-menu-border-radius);\n    bottom: var(--proseMirror-menu-bottom); }\n\n.hideMenuOnBlur .menubar:not(.inputFocus) {\n  display: none; }\n\n.menubar {\n  position: sticky;\n  padding: 5px;\n  z-index: var(--proseMirror-menu-zIndex);\n  background: var(--proseMirror-menu-background);\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5); }\n  .menubar .Divider {\n    border-left: var(--proseMirror-menuDivider-width) solid var(--proseMirror-menu-color);\n    height: var(--proseMirror-menuItem-height);\n    width: var(--proseMirror-menuDivider-width);\n    margin: 0 var(--proseMirror-menuDivider-margin); }\n\n.menuitem {\n  background: 0 0;\n  border: none;\n  cursor: pointer;\n  display: inline-block;\n  height: var(--proseMirror-menuItem-height);\n  color: var(--proseMirror-menu-color); }\n  .menuitem :hover {\n    color: var(--proseMirror-menu-hoverColor); }\n  .menuitem .menu-active {\n    color: var(--proseMirror-menu-hoverColor);\n    background: unset;\n    border-radius: unset; }\n\n.menu-dropdown-menu {\n  background: var(--proseMirror-menu-background);\n  color: var(--proseMirror-menu-color);\n  border: none;\n  cursor: pointer; }\n\n.ColorSelect {\n  background-color: var(--proseMirror-menu-background);\n  border-radius: 5px;\n  padding: 5px;\n  width: 190px; }\n  .ColorSelect > div {\n    width: 15px;\n    height: 15px;\n    margin: 5px;\n    display: inline-block;\n    border: 1px #fff solid;\n    background: var(--color);\n    cursor: pointer; }\n\n.SizeSelect {\n  background-color: var(--proseMirror-menu-background);\n  border-radius: 5px;\n  padding: 5px;\n  width: 100px; }\n  .SizeSelect > span {\n    margin: 5px;\n    color: var(--proseMirror-menu-color);\n    display: block;\n    cursor: pointer;\n    white-space: nowrap; }\n\n.LinkTooltip {\n  max-height: 38px;\n  font-size: 13px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  box-shadow: 0 0 5px #ddd;\n  color: #444;\n  padding: 5px 12px;\n  white-space: nowrap;\n  display: inline-flex;\n  align-items: center;\n  line-height: 18px; }\n  .LinkTooltip a.pm-preview {\n    color: #06c;\n    font-size: 13px;\n    display: inline-block;\n    margin-left: 5px;\n    margin-right: 5px;\n    max-width: 200px;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    vertical-align: top; }\n  .LinkTooltip a.pm-action {\n    color: #06c;\n    margin-left: 5px;\n    margin-right: 5px;\n    font-size: 10px;\n    cursor: pointer; }\n  .LinkTooltip a.pm-remove {\n    color: #06c;\n    margin-left: 5px;\n    margin-right: 5px;\n    font-size: 10px;\n    cursor: pointer; }\n\n.ProseMirror {\n  background: transparent;\n  border: var(--proseMirror-border-width) solid var(--proseMirror-border-color);\n  transition: border .35s ease;\n  outline: none;\n  box-shadow: none;\n  padding: 5px; }\n  .ProseMirror:hover, .ProseMirror:focus {\n    border-color: var(--proseMirror-active-border-color); }\n  .ProseMirror > *:first-child {\n    margin-top: 0; }\n  .ProseMirror > *:last-child {\n    margin-bottom: 5px; }\n";

class PbxProseMirror extends HTMLElement {

  constructor () {
    super();

    const keysMap = buildKeymap(schema_5);
    const preventKeysRegex = /(tab)/i;
    const preventKeysMap = {};
    for (const key in keysMap) {
      if (!Object.prototype.hasOwnProperty.call(keysMap, key)) continue
      if (key.split('-').find(k => preventKeysRegex.test(k))) {
        preventKeysMap[key] = keysMap[key];
        delete keysMap[key];
      }
    }

    const preventKeyMapHandler = keydownHandler(preventKeysMap);

    this.basePlugins = [
      buildInputRules(schema_5),

      dropCursor(),
      gapCursor(),

      buildMenuPlugin(),

      keymap(keysMap),
      new Plugin({
        props: {
          handleKeyDown: (view, event) => {
            if (preventKeyMapHandler(view, event)) {
              event.preventDefault();
            }
          }
        }
      }),
      keymap(baseKeymap),

      history(),

      // pbxAnchorChangePlugin,
      new Plugin({
        key: pbxChangePluginKey,
        view: () => ({
          update: () => {
            const content = this._content = this.content;
            this.dispatchEvent(new CustomEvent('change', {
              detail: { value: content }
            }));
          }
        })
      })
    ];

    const shadow = this.attachShadow({ mode: 'open' });

    const container = createElement('div', {
      className: 'container'
    });
    this.container = container;

    const style = createElement('style', {
      innerHTML: css_248z
    });

    shadow.appendChild(container);
    shadow.appendChild(style);

    const view = this.view = new EditorView(container, {
      state: EditorState.create({
        schema: schema_5,
        plugins: this.getAllPmPlugins()
      })
    });

    view.dom.classList.add('ProseMirror-Style-Container');

    this.hideMenuOnBlur = true;
    this.menuPosition = 'bottom';
  }

  get hideMenuOnBlur () {
    return this.container.classList.contains('hideMenuOnBlur')
  }

  set hideMenuOnBlur (hideMenuOnBlur) {
    this.container.classList.toggle('hideMenuOnBlur', hideMenuOnBlur);
  }

  get menuPosition () {
    return this.container.dataset.menuPosition
  }

  set menuPosition (menuPosition) {
    this.container.dataset.menuPosition = menuPosition;
  }

  getAllPmPlugins () {
    return [
      ...this.basePlugins,
      ...this.plugins
    ]
  }

  get plugins () {
    return this._plugins || []
  }

  set plugins (plugins) {
    this._plugins = plugins || [];

    // Apply the new plugins
    this.view.updateState(
      this.view.state.reconfigure({
        plugins: this.getAllPmPlugins()
      })
    );
  }

  get content () {
    return this.view.dom.innerHTML
  }

  set content (content) {
    if (this._content !== content) {
      this._content = content;
      this.view.dom.innerHTML = content;
    }
  }

  // get view() {
  //     return this.shadowRoot.view;
  // }
  //
  // set view(view) {
  //     this.shadowRoot.view = view;
  // }

}

customElements.define('pbx-prosemirror', PbxProseMirror);

export { MenuViewPlugin$1 as MenuViewPlugin, schema_5 as ProseMirrorSchema, buildInputRules$1 as buildInputRules, buildKeymap$1 as buildKeymap, buildMenuPlugin$1 as buildMenuPlugin, findParentNode, findParentNodeClosestToPos, findParentNodeOfType, getFirstParentNode, hasMarkInCurrentRange, setOrUpdateNode, toggleMark };
